<div class="row">
    <div class="col-12">
        <app-plan-chart [from]="from"
                        [to]="to"
        ></app-plan-chart>
    </div>
</div>
